<template>
    <svg height="96" viewBox="0 0 96 96" width="96" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <g fill="none" fill-rule="evenodd">
            <!-- @vue-ignore -->
            <circle cx="62" cy="60" r="8.1" stroke="currentColor" stroke-width="1.8" />
            <!-- @vue-ignore -->
            <path
                d="m61 54.4h2.2941176l-.2588414 7.6245547h-.291541-1.166348-.291541z"
                fill="currentColor"
                fill-rule="nonzero"
            />
            <!-- @vue-ignore -->
            <path
                d="m62.1470588 65.4c.6335031 0 1.1470588-.5135557 1.1470588-1.1470588s-.5135557-1.1470588-1.1470588-1.1470588-1.1470588.5135557-1.1470588 1.1470588.5135557 1.1470588 1.1470588 1.1470588z"
                fill="currentColor"
                fill-rule="nonzero"
            />
            <!-- @vue-ignore -->
            <g stroke="currentColor" stroke-width="2">
                <circle cx="48" cy="48" r="39" />
                <path
                    d="m48 25.3333333c2.5658229 0 4.8887396 1.0400052 6.5702005 2.7214662 1.681461 1.6814609 2.7214662 4.0043776 2.7214662 6.5702005s-1.0400052 4.8887396-2.7214662 6.5702005c-1.6814609 1.681461-4.0043776 2.7214662-6.5702005 2.7214662s-4.8887396-1.0400052-6.5702005-2.7214662c-1.681461-1.6814609-2.7214662-4.0043776-2.7214662-6.5702005s1.0400052-4.8887396 2.7214662-6.5702005c1.6814609-1.681461 4.0043776-2.7214662 6.5702005-2.7214662z"
                />
                <path
                    d="m53 66.9583333c-3.9212678 0-9.8725027 0-17.7150384 0-2.209139 0-4-1.7143284-4-3.8290598v-3.1709402c0-3.8659932 3.2739178-7 7.3125-7h14.4025384"
                />
            </g>
        </g>
    </svg>
</template>
